import React, { useState, useEffect, useRef } from "react";
import {
  MdLocationOn,
  MdCalendarToday,
  MdPhone,
  MdPerson,
  MdMoreVert,
  MdVisibility,
  MdCheckCircle,
  MdCancel,
  MdAssignmentReturn,
  MdLocalShipping,
} from "react-icons/md";
import { FaStar, FaRegStar } from "react-icons/fa";
import "../../../assets/css/components/deliveryPanel/jobCard/JobCard.css";

const StarRating = ({ rating = 0 }) => (
  <div className="jc-card__stars">
    {[1, 2, 3, 4, 5].map((star) => (
      <span
        key={star}
        className={`jc-card__star ${star <= rating ? "" : "jc-card__star--empty"}`}
      >
        {star <= rating ? <FaStar /> : <FaRegStar />}
      </span>
    ))}
  </div>
);

const badgeConfig = {
  assigned: { label: "Assigned", className: "jc-card__badge--assigned" },
  ready_for_pickup: { label: "Ready for Pickup", className: "jc-card__badge--assigned" },
  shipping: { label: "Out for Delivery", className: "jc-card__badge--assigned" },
  arrived: { label: "Arrived", className: "jc-card__badge--assigned" },
  completed: { label: "Completed", className: "jc-card__badge--completed" },
  cancelled: { label: "Cancelled", className: "jc-card__badge--cancelled" },
  returned: { label: "Returned", className: "jc-card__badge--returned" },
  return_completed: { label: "Return Completed", className: "jc-card__badge--returned" },
};

const JobCard = ({
  orderId,
  status = "assigned",
  customerName,
  customerPhone,
  address,
  date,
  totalAmount,
  deliveryFee,
  review,
  onViewDetail,
  onReviewClick,
  jobId,
  changeJobStatus,
  onMarkPickedUp,
  onMarkArrived,
  onRequestOtp,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const badge = badgeConfig[status] || badgeConfig.assigned;
  return (
    <div className={`jc-card jc-card--${status}`}>
      <div className="jc-card__top">
        <div className="jc-card__order-meta">
          <h6 className="jc-card__order-id">Order {orderId}</h6>
          <span className="jc-card__date">
            <MdCalendarToday />
            {date}
          </span>
        </div>

        <div className="jc-card__top-right">
          <span className={`jc-card__badge ${badge.className}`}>
            {badge.label}
          </span>

          {status === "ready_for_pickup" && (
            <div className="jc-card__menu-wrap" ref={dropdownRef}>
              <button
                className="jc-card__menu-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDropdown((prev) => !prev);
                }}
              >
                <MdMoreVert />
              </button>
              {showDropdown && (
                <div
                  className="jc-card__dropdown"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="jc-card__dropdown-item jc-card__dropdown-item--view"
                    onClick={() => {
                      setShowDropdown(false);
                      onViewDetail && onViewDetail();
                    }}
                  >
                    <MdVisibility /> View Detail
                  </button>

                  <button
                    className="jc-card__dropdown-item jc-card__dropdown-item--complete"
                    onClick={() => {
                      setShowDropdown(false);
                      onMarkPickedUp && onMarkPickedUp(jobId);
                    }}
                  >
                    <MdLocalShipping /> Confirm Pickup
                  </button>
                </div>
              )}
            </div>
          )}

          {/* ── "shipping" — driver abhi raste mein hai. Sirf "I've
               Arrived" dikhta hai — OTP/Mark-Completed yahan available
               nahi, kyunki customer ko doorstep-check ka mauka "arrived"
               status ke baad hi milta hai ── */}
          {status === "shipping" && (
            <div className="jc-card__menu-wrap" ref={dropdownRef}>
              <button
                className="jc-card__menu-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDropdown((prev) => !prev);
                }}
              >
                <MdMoreVert />
              </button>
              {showDropdown && (
                <div
                  className="jc-card__dropdown"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="jc-card__dropdown-item jc-card__dropdown-item--view"
                    onClick={() => {
                      setShowDropdown(false);
                      onViewDetail && onViewDetail();
                    }}
                  >
                    <MdVisibility /> View Detail
                  </button>

                  <button
                    className="jc-card__dropdown-item jc-card__dropdown-item--complete"
                    onClick={() => {
                      setShowDropdown(false);
                      onMarkArrived && onMarkArrived(jobId);
                    }}
                  >
                    <MdLocalShipping /> I've Arrived
                  </button>

                  <button
                    className="jc-card__dropdown-item jc-card__dropdown-item--cancel"
                    onClick={() => {
                      setShowDropdown(false);
                      changeJobStatus && changeJobStatus(jobId, "cancelled");
                    }}
                  >
                    <MdCancel /> Cancel Order
                  </button>
                </div>
              )}
            </div>
          )}

          {/* ── "arrived" — driver dorstep par khada hai, product abhi
               gari mein hai. Customer apni webapp se check kar raha hai
               — agar theek ho to driver "Mark Completed" (OTP-flow) daba
               sakta hai; agar customer reject kare, wo khud apni webapp
               se karega — job status khud "returned" ho jayega, driver
               ki taraf se koi action nahi hai us case mein. ── */}
          {status === "arrived" && (
            <div className="jc-card__menu-wrap" ref={dropdownRef}>
              <button
                className="jc-card__menu-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDropdown((prev) => !prev);
                }}
              >
                <MdMoreVert />
              </button>
              {showDropdown && (
                <div
                  className="jc-card__dropdown"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="jc-card__dropdown-item jc-card__dropdown-item--view"
                    onClick={() => {
                      setShowDropdown(false);
                      onViewDetail && onViewDetail();
                    }}
                  >
                    <MdVisibility /> View Detail
                  </button>

                  <button
                    className="jc-card__dropdown-item jc-card__dropdown-item--complete"
                    onClick={() => {
                      setShowDropdown(false);
                      onRequestOtp && onRequestOtp(jobId);
                    }}
                  >
                    <MdCheckCircle /> Mark Completed
                  </button>
                </div>
              )}
            </div>
          )}

          {!["ready_for_pickup", "shipping", "arrived"].includes(status) && (
            <div className="jc-card__menu-wrap">
              <button
                className="jc-card__menu-btn"
                onClick={() => onViewDetail && onViewDetail()}
                title="View Detail"
              >
                <MdVisibility />
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="jc-card__info-row">
        <div className="jc-card__info-item jc-card__info-item--name">
          <MdPerson className="jc-card__info-icon" />
          <span className="jc-card__info-value">{customerName}</span>
        </div>

        <div className="jc-card__info-item">
          <MdPhone className="jc-card__info-icon" />
          <span className="jc-card__info-value">{customerPhone}</span>
        </div>

        <div className="jc-card__info-item jc-card__info-item--address">
          <MdLocationOn className="jc-card__info-icon" />
          <span className="jc-card__info-value">{address}</span>
        </div>
      </div>

      {/* {status === "completed" && review && (
        <div
          className="jc-card__review"
          onClick={() => onReviewClick && onReviewClick()}
        >
          <StarRating rating={review.rating} />
          {review.comment && (
            <p className="jc-card__review-text">"{review.comment}"</p>
          )}
          <span className="jc-card__review-hint">View Review →</span>
        </div>
      )} */}

      <div className="jc-card__footer">
        <div className="jc-card__fee-item">
          <span className="jc-card__fee-label">Order Total:</span>
          <span className="jc-card__fee-value jc-card__fee-value--green">
            PKR {totalAmount?.toLocaleString()}
          </span>
        </div>
        <div className="jc-card__fee-item">
          <span className="jc-card__fee-label">Your Delivery Fee:</span>
          <span className="jc-card__fee-value jc-card__fee-value--blue">
            PKR {deliveryFee?.toLocaleString()}
          </span>
        </div>
        <div className="jc-card__fee-item jc-card__fee-item--grand">
          <span className="jc-card__fee-label">Grand Total:</span>
          <span className="jc-card__fee-value jc-card__fee-value--grand">
           PKR {(Number(totalAmount || 0) + Number(deliveryFee || 0)).toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default JobCard;
